<template>
    <address-item-base :address="address">
        <template slot-scope="{ remove }">
            <a href="#" class="mb-3 w-full md:w-1/2 lg:w-1/3">
                <div class="transition-all ease-in-out duration-1000 flex flex-col justify-center mx-0">
                    <div slot="bottom-center">
                        <div class="p-2 shadow-md m-2 mt-4">
                            <i class="text-xl mb-5 flex flex-row justify-between">
                                {{ address.name }}

                                <a href="#" @click.stop="remove">
                                    <svg class="w-6 h-6 " fill="none" stroke="currentColor" viewBox="0 0 24 24"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                              d="M6 18L18 6M6 6l12 12"></path>
                                    </svg>
                                </a>
                            </i>
                            <div class="my-5">

                                <address>
                                    <div v-if="address.address">{{ address.address.billing_name }}</div>
                                    <div v-if="address.billingName">{{ address.billingName }}</div>
                                    <div>{{ address.city }}</div>
                                    <div>{{ address.street }} {{ houseNumber }}</div>
                                    <div>{{ postCode }}</div>
                                    <div>{{ address.taxNumber }}</div>
                                </address>
                            </div>
                        </div>
                    </div>
                </div>
            </a>
        </template>
    </address-item-base>
</template>

<script>
export default {
    props: {
        address: {
            type: Object,
            required: true
        }
    },
    computed: {
        houseNumber() {
            if (this.address.hasOwnProperty('house_number')) {
                return this.address.house_number
            }

            return this.address.houseNumber
        },

        postCode() {
            if (this.address.hasOwnProperty('post_code')) {
                return this.address.post_code
            }

            return this.address.postalCode
        },
    }
}
</script>
